import React from "react";
import Form from "../../common/form";
import ReactModal from "react-modal";
import schema from './mobileLogisticsPlanningDataFormSchema';
import {dateToString} from "../../../services/dateTimeFormat";
import {get as getLogisticsPlanning} from "../../../services/http/logisticsPlanningService";
import {getApiUrl} from "../../../services/http/httpService";
import {
    getChangedCheckboxValue,
    getSortedListFromBackendMap,
    getStandardCheckboxValue
} from "../../../services/toolsService";

class MobileLogisticsPlanningDataForm extends Form {

    constructor() {
        super();
        this.setDataAndSchema();

    }

    state = {
        ...this.state,
        receiver2ContactPersonsMap: {},
        receiver2ContactPersonList: [],
        vendor2ContactPersonsMap: {},
        vendor2ContactPersonList: [],
        carrier2ContactPersonsMap: {},
        carrier2ContactPersonList: [],
        sortVehicles: {
            currentPage: 1,
            pageSize: 1000,
            sortColumn: {path: "registration", order: "asc"},
            searchQuery: ""
        }
    }

    baseInformation = schema;

    componentDidMount = async () => {

        const {showModal, selectedLogicticsPlanningDbId, selectedSlot, credentials} = this.props;
        const {data} = this.state;

        if (!showModal)
            return;

        if (selectedLogicticsPlanningDbId === 0 && !selectedSlot)
            return;

        if (selectedLogicticsPlanningDbId === 0) {
            // neuer Datensatz
            const newData = {...data};
            newData.start = dateToString(selectedSlot.start, "YYYYMMDDHHmm");
            newData.end = dateToString(selectedSlot.end, "YYYYMMDDHHmm");
            newData.vehicles = []
            newData.ressourcesMap = {}
            newData.loadingPlacesMap = {}
            this.setState({data: newData});
        } else if (selectedLogicticsPlanningDbId === -2) {
            // neuer Datensatz (freier Event)
            const newData = {...data};
            newData.start = dateToString(selectedSlot.start, "YYYYMMDDHHmm");
            newData.end = dateToString(selectedSlot.end, "YYYYMMDDHHmm");
            newData.vehicles = []
            newData.ressourcesMap = {}
            let loadingPlacesMap = {}
            loadingPlacesMap[selectedSlot.selectedLoadingPlaceDbId] = {
                dbId: 0,
                referenceDbId: selectedSlot.selectedLoadingPlaceDbId,
                checked: true,
                enabled: true
            };
            newData.loadingPlacesMap = loadingPlacesMap
            this.setState({data: newData});
        } else {

            const request = await getLogisticsPlanning(
                credentials,
                getApiUrl() +
                "/" +
                "secClockworkLogisticsPlanning" +
                "?dbId=" + selectedLogicticsPlanningDbId
            );

            let newData = request.data.data.logisticsPlanning

            const {receiver2ContactPersonsMap: newReceiver2ContactPersonsMap, receiver2ContactPersonList: newReceiver2ContactPersonList} = this.getReceiverContactPersons(newData.receiver.company)
            const {vendor2ContactPersonsMap: newVendor2ContactPersonsMap, vendor2ContactPersonList: newVendor2ContactPersonList} = this.getVendorContactPersons(newData.vendor.company)
            const {carrier2ContactPersonsMap: newCarrier2ContactPersonsMap, carrier2ContactPersonList: newCarrier2ContactPersonList} = this.getCarrierContactPersons(newData.carrier.company)

            this.setState({
                data: newData,
                receiver2ContactPersonsMap: newReceiver2ContactPersonsMap,
                receiver2ContactPersonList: newReceiver2ContactPersonList,
                vendor2ContactPersonsMap: newVendor2ContactPersonsMap,
                vendor2ContactPersonList: newVendor2ContactPersonList,
                carrier2ContactPersonsMap: newCarrier2ContactPersonsMap,
                carrier2ContactPersonList: newCarrier2ContactPersonList
            })

        }

    };

    onChangeReceiver = (event) => {

        const {value} = event.currentTarget;
        const {receiversMap} = this.props;

        this.handleChange(event)

        const newData = {...this.state.data}
        newData.receiver.contactPerson = 0            // damit diese automatisch wieder auf den ersten Eintrag pro Receiver gesetzt wird
        // let newReceiver2ContactPersonsMap = {}
        // let newReceiver2ContactPersonList = []
        // if (value > 0) {
        //     newReceiver2ContactPersonsMap = {...receiversMap[value]["company2ConcatPersonsMap"]};
        //     newReceiver2ContactPersonList = getSortedListFromBackendMap(newReceiver2ContactPersonsMap, ["name"], ["name"]);
        // }
        const {receiver2ContactPersonsMap: newReceiver2ContactPersonsMap, receiver2ContactPersonList: newReceiver2ContactPersonList} = this.getReceiverContactPersons(value)
        this.setState({
            data: newData,
            receiver2ContactPersonsMap: newReceiver2ContactPersonsMap,
            receiver2ContactPersonList: newReceiver2ContactPersonList
        })

        // console.log("MobileLogisticsPlanningDataForm.onChangeReceiver(): value=", event.currentTarget.value)
    }

    getReceiverContactPersons(receiverDbId) {

        const {receiversMap} = this.props;

        let newReceiver2ContactPersonsMap = {}
        let newReceiver2ContactPersonList = []

        if (receiverDbId > 0 && receiversMap[receiverDbId]) {
            newReceiver2ContactPersonsMap = {...receiversMap[receiverDbId]["company2ConcatPersonsMap"]};
            newReceiver2ContactPersonList = getSortedListFromBackendMap(newReceiver2ContactPersonsMap, ["name"], ["name"]);
        }

        return {
            receiver2ContactPersonsMap: newReceiver2ContactPersonsMap,
            receiver2ContactPersonList: newReceiver2ContactPersonList
        }

    }

    onChangeReceiverContactPerson = (event) => {
        this.handleChange(event)
        // console.log("MobileLogisticsPlanningDataForm.onChangeReceiverContactPerson(): value=", event.currentTarget.value)
    }

    onChangeVendor = (event) => {

        const {value} = event.currentTarget;
        const {vendorsMap} = this.props;

        this.handleChange(event)

        const newData = {...this.state.data}
        newData.vendor.contactPerson = 0            // damit diese automatisch wieder auf den ersten Eintrag pro Vendor gesetzt wird
        // let newVendor2ContactPersonsMap = {}
        // let newVendor2ContactPersonList = []
        // if (value > 0) {
        //     newVendor2ContactPersonsMap = {...vendorsMap[value]["company2ConcatPersonsMap"]};
        //     newVendor2ContactPersonList = getSortedListFromBackendMap(newVendor2ContactPersonsMap, ["name"], ["name"]);
        // }
        const {vendor2ContactPersonsMap: newVendor2ContactPersonsMap, vendor2ContactPersonList: newVendor2ContactPersonList} = this.getVendorContactPersons(value)
        this.setState({
            data: newData,
            vendor2ContactPersonsMap: newVendor2ContactPersonsMap,
            vendor2ContactPersonList: newVendor2ContactPersonList
        })

        // console.log("MobileLogisticsPlanningDataForm.onChangeVendor(): value=", event.currentTarget.value)
    }

    getVendorContactPersons(vendorDbId) {

        const {vendorsMap} = this.props;

        let newVendor2ContactPersonsMap = {}
        let newVendor2ContactPersonList = []

        if (vendorDbId > 0 && vendorsMap[vendorDbId]) {
            newVendor2ContactPersonsMap = {...vendorsMap[vendorDbId]["company2ConcatPersonsMap"]};
            newVendor2ContactPersonList = getSortedListFromBackendMap(newVendor2ContactPersonsMap, ["name"], ["name"]);
        }

        return {
            vendor2ContactPersonsMap: newVendor2ContactPersonsMap,
            vendor2ContactPersonList: newVendor2ContactPersonList
        }

    }

    onChangeVendorContactPerson = (event) => {
        this.handleChange(event)
        // console.log("MobileLogisticsPlanningDataForm.onChangeVendorContactPerson(): value=", event.currentTarget.value)
    }

    onChangeCarrier = (event) => {

        const {value} = event.currentTarget;
        const {carriersMap} = this.props;

        this.handleChange(event)

        const newData = {...this.state.data}
        newData.carrier.contactPerson = 0            // damit diese automatisch wieder auf den ersten Eintrag pro Carrier gesetzt wird
        // let newCarrier2ContactPersonsMap = {}
        // let newCarrier2ContactPersonList = []
        // if (value > 0) {
        //     newCarrier2ContactPersonsMap = {...carriersMap[value]["company2ConcatPersonsMap"]};
        //     newCarrier2ContactPersonList = getSortedListFromBackendMap(newCarrier2ContactPersonsMap, ["name"], ["name"]);
        // }
        const {carrier2ContactPersonsMap: newCarrier2ContactPersonsMap, carrier2ContactPersonList: newCarrier2ContactPersonList} = this.getCarrierContactPersons(value)
        this.setState({
            data: newData,
            carrier2ContactPersonsMap: newCarrier2ContactPersonsMap,
            carrier2ContactPersonList: newCarrier2ContactPersonList
        })

        // console.log("MobileLogisticsPlanningDataForm.onChangeCarrier(): value=", event.currentTarget.value)
    }

    getCarrierContactPersons(carrierDbId) {

        const {carriersMap} = this.props;

        let newCarrier2ContactPersonsMap = {}
        let newCarrier2ContactPersonList = []

        if (carrierDbId > 0 && carriersMap[carrierDbId]) {
            newCarrier2ContactPersonsMap = {...carriersMap[carrierDbId]["company2ConcatPersonsMap"]};
            newCarrier2ContactPersonList = getSortedListFromBackendMap(newCarrier2ContactPersonsMap, ["name"], ["name"]);
        }

        return {
            carrier2ContactPersonsMap: newCarrier2ContactPersonsMap,
            carrier2ContactPersonList: newCarrier2ContactPersonList
        }

    }

    onChangeCarrierContactPerson = (event) => {
        this.handleChange(event)
        // console.log("MobileLogisticsPlanningDataForm.onChangeCarrierContactPerson(): value=", event.currentTarget.value)
    }

    onChangeLoadingPlace = (event) => {
        // this.handleChange(event)
        const {currentTarget: input} = event;
        const newData = {...this.state.data};
        if (!newData.loadingPlacesMap[input.id])
            newData.loadingPlacesMap[input.id] = getStandardCheckboxValue(input.id, input.checked)
        else
            newData.loadingPlacesMap[input.id] = getChangedCheckboxValue(newData.loadingPlacesMap[input.id], input.checked)

        this.setState({data: newData});

    }

    onChangeRessource = (event) => {
        // this.handleChange(event)
        const {currentTarget: input} = event;
        const newData = {...this.state.data};
        if (!newData.ressourcesMap[input.id])
            newData.ressourcesMap[input.id] = getStandardCheckboxValue(input.id, input.checked)
        else
            newData.ressourcesMap[input.id] = getChangedCheckboxValue(newData.ressourcesMap[input.id], input.checked)

        this.setState({data: newData});

    }

    // onAddVehicle = () => {
    //     console.log("MobileLogisticsPlanningDataForm.onAddVehicle()")
    //
    // }

    onChangeVehicles = vehicles => {
        // console.log("MobileLogisticsPlanningDataForm.onChangeVehicles(): this.state.data.vehicles=", this.state.data.vehicles)
        // console.log("MobileLogisticsPlanningDataForm.onChangeVehicles(): vehicles=", vehicles)

        // handleChange = ({currentTarget: input})
        const newData = {...this.state.data};
        newData["vehicles"] = [...vehicles]

        this.setState({data: newData});

    }

    onSortVehicles = sortColumn => {
        // console.log("MobileLogisticsPlanningDataForm.onSortVehicles(): newSortColumn=", sortColumn, ", this.state.sortVehicles.sortColumn", this.state.sortVehicles.sortColumn)
        const newSortVehicles = {...this.state.sortVehicles};
        newSortVehicles["sortColumn"] = {...sortColumn};
        this.setState({sortVehicles: newSortVehicles});
    };


    // mapToViewModel(movie) {
    //     return {
    //         id: movie.id,
    //         title: movie.title,
    //         genreId: movie.genre.id,
    //         numberInStock: movie.numberInStock,
    //         dailyRentalRate: movie.dailyRentalRate
    //     };
    // }

    render = () => {
        const {
            selectedLogicticsPlanningDbId,
            showModal, style, ariaHideApp,
            receiversMap, receiverList,
            vendorsMap, vendorList,
            carriersMap, carrierList,
            ressourcesMap, ressourceList,
            loadingPlacesMap, loadingPlaceList,
            vehicleTypesMap, vehicleTypeList,
        } = this.props;
        const {
            data,
            receiver2ContactPersonsMap,
            receiver2ContactPersonList,
            vendor2ContactPersonsMap,
            vendor2ContactPersonList,
            carrier2ContactPersonsMap,
            carrier2ContactPersonList,
            sortVehicles
        } = this.state;

        return (
            <React.Fragment>
                <ReactModal
                    isOpen={showModal}
                    contentLabel="MobileLogisticsPlanningDataForm"
                    style={style}
                    ariaHideApp={ariaHideApp}
                >
                    <h1>Logistik-Planung</h1>
                    {/*<form onSubmit={this.handleSubmit}>*/}

                    {this.renderCard(
                        "Datum/Zeit",
                        [
                            {"name": "start"},
                            {"name": "end"}
                        ]
                    )}
                    {loadingPlaceList.length > 0 && this.renderCard(
                        "Umschlagplätze",
                        [
                            {
                                "name": "loadingPlacesMap",
                                "itemsMap": loadingPlacesMap,
                                "itemList": loadingPlaceList,
                                "handleCheckboxChange": this.onChangeLoadingPlace
                            }
                        ]
                    )}
                    {/*{this.renderButton({*/}
                    {/*    label: "prüfen",*/}
                    {/*    onClick: this.onConfiguration,*/}
                    {/*    className: "btn-info"*/}
                    {/*})}*/}
                    {this.renderCard(
                        "Empfänger",
                        [
                            {
                                "name": "receiver.company",
                                "itemsMap": receiversMap,
                                "itemList": receiverList,
                                // "nullable": "false",
                                "handleItemSelect": this.onChangeReceiver
                            },
                            {
                                "name": "receiver.contactPerson",
                                "itemsMap": receiver2ContactPersonsMap,
                                "itemList": receiver2ContactPersonList,
                                // "nullable": "false",
                                "handleItemSelect": this.onChangeReceiverContactPerson,
                                "key": new Date().getTime()          // damit wird componentDidMount jedenfalls ausgefuehrt - auch wenn diese Componente zweima hintereinander gestartet wird
                                                                     // ... damit SelectByList.selectFirstOption() tatsaechlich ausgefuehrt wird
                                                                     // ... weil eben receiver.contactPerson abhaenig von receiver.receiver ist
                            }
                        ]
                    )}
                    {this.renderCard(
                        "Lieferant",
                        [
                            {
                                "name": "vendor.company",
                                "itemsMap": vendorsMap,
                                "itemList": vendorList,
                                // "nullable": "false",
                                "handleItemSelect": this.onChangeVendor
                            },
                            {
                                "name": "vendor.contactPerson",
                                "itemsMap": vendor2ContactPersonsMap,
                                "itemList": vendor2ContactPersonList,
                                // "nullable": "false",
                                "handleItemSelect": this.onChangeVendorContactPerson,
                                "key": new Date().getTime()          // damit wird componentDidMount jedenfalls ausgefuehrt - auch wenn diese Componente zweima hintereinander gestartet wird
                                                                     // ... damit SelectByList.selectFirstOption() tatsaechlich ausgefuehrt wird
                                                                     // ... weil eben vendor.contactPerson abhaenig von vendor.vendor ist
                            },
                            {"name": "vendor.iName"},
                            {"name": "vendor.iContactPerson.firstname"},
                            {"name": "vendor.iContactPerson.surname"},
                            {"name": "vendor.iContactPerson.mobilePhone"},
                            {"name": "vendor.iContactPerson.email"}
                        ]
                    )}
                    {this.renderCard(
                        "Spediteur",
                        [
                            {
                                "name": "carrier.company",
                                "itemsMap": carriersMap,
                                "itemList": carrierList,
                                // "nullable": "false",
                                "handleItemSelect": this.onChangeCarrier
                            },
                            {
                                "name": "carrier.contactPerson",
                                "itemsMap": carrier2ContactPersonsMap,
                                "itemList": carrier2ContactPersonList,
                                // "nullable": "false",
                                "handleItemSelect": this.onChangeCarrierContactPerson,
                                "key": new Date().getTime()          // damit wird componentDidMount jedenfalls ausgefuehrt - auch wenn diese Componente zweima hintereinander gestartet wird
                                                                     // ... damit SelectByList.selectFirstOption() tatsaechlich ausgefuehrt wird
                                                                     // ... weil eben carrier.contactPerson abhaenig von carrier.carrier ist
                            },
                            {"name": "carrier.iName"},
                            {"name": "carrier.iContactPerson.firstname"},
                            {"name": "carrier.iContactPerson.surname"},
                            {"name": "carrier.iContactPerson.mobilePhone"},
                            {"name": "carrier.iContactPerson.email"}
                        ]
                    )}
                    {vehicleTypeList.length > 0 && this.renderCard(
                        "Fahrzeugdaten",
                        [
                            {
                                "name": "vehicles",
                                "sort": sortVehicles,
                                "handleChange": this.onChangeVehicles,
                                "handleSort": this.onSortVehicles,
                                "columns": [
                                    {
                                        path: "registration",
                                        label: "Kennzeichen",
                                        // content: movie => <Link to={`/movies/${movie.id}`}>{movie.title}</Link>
                                    },
                                    {
                                        path: "vehicleType",
                                        label: "KFZ-Typ",
                                        // itemsMap: vehicleTypesMap,
                                        // itemList: vehicleTypeList,
                                    }
                                ],
                                "addButton": {
                                    text: "Fahrzeug hinzufügen",
                                    // handleAdd: this.onAddVehicle
                                },
                                "deleteButton": {
                                    text: "löschen"
                                },
                                itemsMap: vehicleTypesMap,              // TODO
                                itemList: vehicleTypeList               // TODO
                            }
                        ],
                    )}
                    {ressourceList.length > 0 && this.renderCard(
                        "Ressourcen",
                        [
                            {
                                "name": "ressourcesMap",
                                "itemsMap": ressourcesMap,
                                "itemList": ressourceList,
                                "handleCheckboxChange": this.onChangeRessource
                            }
                        ]
                    )}

                    <div className="card">
                        <div className="card-body">
                            <div className="form-group row">
                                <div className="col-md-1">
                                    {this.renderSaveButton({})}
                                </div>
                                {selectedLogicticsPlanningDbId > 0 && (
                                    <div className="col-md-1">
                                        {this.renderDeleteButton({})}
                                    </div>
                                )}
                                <div className="col-md-1">
                                    {this.renderCancelButton({})}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*</form>*/}
                </ReactModal>
            </React.Fragment>
        );
    }
}

export default MobileLogisticsPlanningDataForm;
